var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronLeftSlide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.994,
    height: 60.994,
    viewBox: "0 0 26.994 60.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_763",
    "data-name": "\\uADF8\\uB8F9 763",
    transform: "translate(3.497 3.497)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_90",
    "data-name": "\\uC120 90",
    x1: 20,
    y2: 27,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#545e77",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_91",
    "data-name": "\\uC120 91",
    x1: 20,
    y1: 27,
    transform: "translate(0 27)",
    fill: "none",
    stroke: "#545e77",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftSlide);
export default __webpack_public_path__ + "static/media/chevron_left_slide.5992662becc3b8c47cb41384aa64ec55.svg";
export { ForwardRef as ReactComponent };